<script>
import SubHeader from "@/components/SubHeader";
export default {
  components: {
    SubHeader,
  },
  data: () => ({
    headerProps: {
      title: "Gerenciar Naturezas de Operações",
      btns: [
        {
          text: "Novo",
          color: "primary",
          action: () => {},
          icon: "mdi-plus",
          path: "/cadastros/naturezas-operacao/new",
          isRedirector: true,
        },
        {
          text: "Recarregar",
          color: "primary",
          action: () => {},
          icon: "mdi-update",
          path: "",
          isRedirector: false,
        },
      ],
    },
    dialog: false,
    search: "",
    headers: [
      { text: "Descrição", value: "descricao", sortable: false },
      { text: "Ações", align: "right", value: "action", sortable: false },
    ],
    items: [],
  }),
  created() {
    this.initialize();
    this.headerProps.btns[1].action = () => this.initialize();
  },
  methods: {
    handleSearch: function (value) {
      this.search = value;
    },
    initialize() {
      this.items = [];
      this.$store.dispatch("activeLoader", true);
      this.$http.get("/natureza-operacoes").then((r) => {
        this.items = r.data;
        this.$store.dispatch("activeLoader", false);
      });
    },
    editar(id) {
      this.$router.push(`/cadastros/naturezas-operacao/editar/${id}`);
    },
    deleteItem(id) {
      let c = confirm("Deseja apagar o registro?");
      if (c) {
        this.$store.dispatch("activeLoader", true);
        this.$http.post(`/natureza-operacoes/delete/${id}`).then((r) => {
          this.$store.dispatch("activeLoader", false);
          alert(r.data.success);
          this.initialize();
        });
      }
    },
  },
};
</script>
